import ConfirmDialog from './index.vue'

const obj = {}
obj.install = function(Vue) {
  const ConfirmConstructor = Vue.extend(ConfirmDialog)
  const confirm = new ConfirmConstructor()
  confirm.$mount(document.createElement('div'))
  document.body.appendChild(confirm.$el)

  // this.$confirm.show('内容') 返回 Promise<boolean>
  Vue.prototype.$confirm = confirm
}
export default obj



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog/index.js